import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";

const getDate = function(millis) {
  if (millis === undefined) {
    return "N/A";
  }
  return new Date(parseInt(millis)).toUTCString();
};

export default function(props) {
  const { errorlogs } = props;

  logger.log("errorlogs", errorlogs);
  return (
    <TaskDialog heading={"Notifications"} fullScreen={true}>
      {errorlogs &&
        Object.keys(errorlogs).map((key) => {
          const value = errorlogs[key];
          return (
            <div style={{ fontSize: "15px" }}>
              {getDate(key)} - {value}
            </div>
          );
        })}
    </TaskDialog>
  );
}
